export default __webpack_public_path__ + "static/media/no-data.01288044.svg";